import styles from '../../assets/styles/LandingPage/About.module.scss';
import { MimaButton, MimaText } from '../../components';
import React from 'react';
import Footer from './Footer';
import AboutImg from '../../assets/img/Mima team.jpg';
import Puzzle from '../../assets/img/jigsaw.jpg';
import Header3 from './Header3';
import PlayStoreIcon from '../../assets/img/playstore.png';
import AppleStoreIcon from '../../assets/img/apple.png';
import { slides } from '../../utils/testimonialData';
import constant from '../../utils/constant';
import { useNavigate } from 'react-router';
import { useMediaQuery } from 'react-responsive';

const About = () => {
    const navigate = useNavigate();
    const switchToSignup = () => {
        navigate(constant.Routes.SignUp);
    };

    const aboutText = [
        {
            lead: "We have a passion...",
            content: "...for helping businesses thrive. We have developed a comprehensive suite of tools and services designed to streamline your operations and drive success.",
        },
        {
            lead: "Our mission is to empower...",
            content: "... businesses of all sizes by providing them with tools they need to manage and grow effectively. With our user-friendly interface, we offer a range of features that encompass various aspects of business management. From **Invoice & Receipt creation, Business analytics, Inventory/Stock Management, Customer Management, Employee and Payroll Management. Other features are Payment Links creation, Bill Payments, Bulk SMS, Petty-cash wallet, Vendor Management, Booking Links creation and Business Account Number generation.** Our solutions are designed to enhance productivity, optimize processes and increase profitability.",
        },
        {
            lead: "We are set apart by...",
            content: "...our commitment to exceptional customer service. We believe in building strong, long-lasting partnerships with our clients. Our dedicated support team is always ready to assist our customers, providing personalized guidance and prompt resolution to anyqueries or concerns you may have.",
        },
        {
            lead: "We take pride in...",
            content: "...our track record of delivering reliable, scalable and secure solutions that align with your unique business requirements.",
        },
        {
            lead: "Our goal is...",
            content: "...to be your trusted partner in achieving sustainable business growth and success.",
        },
    ]

    const renderBoldText = (text) => {
        const parts = text.split('**');
        return parts.map((part, index) => {
            if (index % 2 === 0) {
                return part; // Non-bold text
            } else {
                return <strong key={index}>{part}</strong>; // Bold text
            }
        });
    };


    const appleIcon = <img src={AppleStoreIcon} alt='Mima Business on ios' className={styles.join__btn__icon} />;

    const playIcon = <img src={PlayStoreIcon} alt='Mima Business on android' className={styles.join__btn__icon} />;

    const testimonial = slides.slice(0, 3);

    const isBelow800 = useMediaQuery({
        query: '(max-width: 800px)',
    });

    return (
        <>
            <Header3 />
            <section className={styles.container}>
                <MimaText variant="h3" align="center" mt={4}>About Us</MimaText>
                <MimaText variant="subtitleBold" color="var(--color-primary)" align="center" mt={2} mr={4} ml={4}>
                    Providing innovative business management solutions <br /> for small, medium and large scale enterprises
                </MimaText>
                <div className={styles.container__team}>
                    <img
                        src={AboutImg}
                        alt='About Mima Business'
                        className={styles.container__team__img}
                    />
                </div>

                <MimaText variant="h3" mb={3}>
                    The missing piece to your <br /> business growth puzzle.
                </MimaText>

                <div className={styles.content__grid}>

                    <div>
                        <img
                            src={Puzzle}
                            alt='Mima Business the missing piece for your business'
                        />
                    </div>
                    <div>
                        {aboutText.map((text, i) => (
                            <React.Fragment key={i}>
                                <MimaText variant="subtitleBold" color="var(--color-primary-4)" mb={1}>
                                    {text.lead}
                                </MimaText>
                                <MimaText mb={2} variant="body2">
                                    {renderBoldText(text.content)}
                                </MimaText>
                            </React.Fragment>
                        ))}
                    </div>

                </div>

            </section>
            <section className={styles.join}>
                <MimaText variant={isBelow800 ? "h3" : "h2"} color="var(--color-white)" align="center" mb={2}>
                    Join us and numerous businesses who already experience the transformational power of our business solution
                </MimaText>
                <MimaText variant="subtitle" color="var(--color-white)" align="center" >
                    Together we can unlock the full potential of your business
                </MimaText>
                <div className={styles.join__btn}>
                    <a href='https://play.google.com/store/apps/details?id=com.mima.mima' style={{ textDecoration: "none" }}>
                        <MimaButton
                            title="Get app on Android"
                            variant="outlined2"
                            icon={playIcon}
                            width={30}

                        />
                    </a>

                    <a href='https://apps.apple.com/us/app/mima-business/id6444887331' style={{ textDecoration: "none" }}>

                        <MimaButton
                            title="Get app on iPhone"
                            variant="outlined2"
                            icon={appleIcon}
                            width={30}
                        />
                    </a>


                </div>
            </section>
            <section className={styles.container}>
                <MimaText variant="h2" align="center" mb={3}>
                    We take pride in the success of our customers.
                </MimaText>
                <div className={styles.content__grid__2}>
                    {testimonial.map((x) => (
                        <div className={styles.content__grid__2__card}>
                            <MimaText variant="smallBold" mb={2}>{x.title}</MimaText>
                            <MimaText variant="body2" mb={2}>{x.testimony}</MimaText>
                            <MimaText variant="bodyBold">{x.name}</MimaText>
                            <MimaText variant="small" mb={3}>{x.business}</MimaText>
                            <div className={styles.testimonialImg} >
                                <img src={x.imgUrl} alt="testimonial" />
                            </div>
                        </div>
                    ))}
                </div>

                <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
                    <MimaButton
                        title="Start Now, Sign up"
                        onClick={switchToSignup}
                        mb={5}
                    />
                </div>
            </section>
            <Footer />
        </>
    );
};

export default About;